import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useAuth } from "../hooks/useAuth";

export default function SuccessPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  // If someone lands here directly without being logged in, redirect home
  useEffect(() => {
    if (!user) navigate("/", { replace: true });
  }, [user, navigate]);

  return (
    <div className="page-wrap">
      <Navbar onLoginClick={() => navigate("/")} />

      <div className="success-screen">
        <div className="success-icon" aria-hidden="true">✓</div>
        <div className="premium-badge">⭐ JB+ Active</div>
        <h2>You're now a JB+ member!</h2>
        <p>
          Your subscription is active. Open the Janmabhoomi app and tap
          "Already a member? Log in" — your premium access will sync automatically.
        </p>
        <button
          className="btn-primary"
          style={{ marginTop: 8 }}
          onClick={() => navigate("/")}
        >
          Back to home
        </button>
      </div>

      <Footer />
    </div>
  );
}
